import React from "react";
import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import styles from "./styles.scss";

function AllocationsList(_: Props) {
  return (
    <div className={styles.allocationsList}>
      <Skeleton className={styles.allocation} />
      <Skeleton className={styles.allocation} />
      <Skeleton className={styles.allocation} />
    </div>
  );
}

export { AllocationsList };
